







































import { Component, Vue, Prop } from 'vue-property-decorator';
import CatalogOrderStore, { CatalogOrderStatus, CatalogOrderDetail } from '@/store/CatalogOrderStore';
import PreferenceStore, { VDataTablePagenation } from '@/store/PreferenceStore';
import AppStore from '@/store/App';
import MaterialCard from '@/components/material/Card.vue';
import Refreshable from '@/components/helper/Refreshable.vue';
import delay from 'delay';

import { parseCombinedAddress, generateCSV } from '@/model/ptouch';


@Component({
  metaInfo() {
    return {
      title: "資料請求一覧",
    }
  },
  components: {
      MaterialCard,
      Refreshable,
  }
})
export default class CatalogOrderList extends Vue {
    headers = [
      {
          sortable: false,
          text: '',
          value: 'check'
      },
      {
          sortable: true,
          text: '新着',
          value: 'processed'
      },
      {
        sortable: true,
        text: '会社名',
        value: 'companyName'
      },
      {
        sortable: true,
        text: '住所',
        value: 'email'
      },
      {
        sortable: true,
        text: '日付',
        value: 'date',
        sort(a: Date, b: Date) {
          return a.valueOf() - b.valueOf();
        }
      },
    ];
    refreshing = false;
    selections: { [key: number]: boolean } = {};
    selectionCount: number = 0;
    get items(): CatalogOrderStatus[] { return CatalogOrderStore.status; }
    selectedItems(): CatalogOrderDetail[] { 
        const ret = [];
        for(const id in this.selections) {
            if(this.selections[id]) ret.push(CatalogOrderStore.details[id]);
        }
        return ret;
    }

    async mounted() {
        await CatalogOrderStore.getStatusList();
    }

    async refresh() {
        this.refreshing = true;
        const d500 = delay(500);
        const update = CatalogOrderStore.updateStatus();
        await Promise.all([d500, update]);
        this.refreshing = false;
    }

    get pagination() {
        return PreferenceStore.catalogOrderTableState;
    }
    set pagination(val) {
        if(this.items.length > 0)
            PreferenceStore.UPDATE_CATALOG_ORDER_TABLE_STATE(val);
    }

    toggleSelection(id: number, val: boolean) {
        if(this.selections[id] && !val) this.selectionCount--;
        else if(!this.selections[id] && val) this.selectionCount++;
        this.selections[id] = val;
    }

    async modifyProcessed(val: boolean) {
        const promises = this.selectedItems().map(x => { const nx = Object.assign({}, x); nx.processed = val ? 1 : 0; return CatalogOrderStore.modifyDetail(nx) });
        await Promise.all(promises);
        await AppStore.showSuccess("正常に更新しました。");
        await CatalogOrderStore.updateUnprocessedCount();
    }

    sendCSV() {
        const entries = this.selectedItems().map(x => { return { ...parseCombinedAddress(x.address), name: x.staffName } });
        const url = 'ptouch:' + encodeURI(generateCSV(entries));

        console.log(url);
        window.location.href = url;
    }
}
